import {useEffect, useState} from 'react';
import axios from 'axios';
import _ from 'lodash';
import {useSelector} from 'react-redux';

const useReverseGeocode = (latitude, longitude, zoom, isDisabled = false) => {
  const [data, setData] = useState(null);
  const userId = useSelector(s => s.inApp.userId);

  useEffect(() => {
    setData(null);
    if (isDisabled) return;
    if (_.isNil(latitude) || _.isNil(longitude)) return;

    // https://nominatim.org/release-docs/latest/api/Reverse/
    axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&zoom=${Math.round(zoom)}`, {
      headers: {
        'User-Agent': `${userId}/1.0`,
      },
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((e) => {
        console.error(e);
      });

  }, [isDisabled, latitude, longitude, userId]);

  const {
    address,
    display_name,
  } = data || {};

  const {
    city,
    country,
    province,
    municipality,
    region,
    state,
    state_district,
    town,
    village,
  } = address || {};

  console.log(display_name, JSON.stringify(address, null, 2))

  // https://nominatim.org/release-docs/latest/api/Output/#addressdetails
  return data
    ? {
      city,
      cityCommaCountry: _.compact([
        city || municipality || town || village,
        state || state_district || province || region,
        country,
      ]).join(', '),
      country,
      displayName: display_name,
      province,
      state,
    }
    : {};
};

export default useReverseGeocode;
